<template>
    <div>
        <section class="signup-step-container">
            <div class="container">
                <div class="row d-flex justify-content-center bg-white">
                    <div class="wizard">
                        <div class="wizard-inner">
                            <div class="connecting-line" />
                            <ul class="nav nav-tabs" role="tablist">
                                <li
                                    v-for="(step, index) in steps"
                                    :key="step"
                                    role="presentation"
                                    :class="[index + 1 === currentStep ? 'active' : 'disabled']"
                                >
                                    <a
                                        data-toggle="tab"
                                        :aria-controls="`step${step}`"
                                        role="tab"
                                        aria-expanded="true"
                                        :class="[!showStep4 && index == 3 ? 'step-disable' : '']"
                                    >
                                        <span class="round-tab">{{ index + 1 }} </span>
                                        <div
                                            v-for="(item, key) in getStepTitleByLanguage(step)"
                                            :key="key"
                                            class="d-flex flex-wrap"
                                        >
                                            <span v-if="key == 0" class="step-title">
                                                {{ item }}
                                            </span>
                                            <span
                                                v-else
                                                :class="
                                                    index % 2 != 0
                                                        ? 'step-title bottom mt-4 mt-md-0'
                                                        : 'step-title bottom'
                                                "
                                            >
                                                {{ item }}
                                            </span>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'Step',
    components: {},
    props: {
        currentStep: { type: Number, required: true },
        showStep4: { type: Boolean, default: false },
    },
    data() {
        return {
            ignoreValidation: true,
            steps: ['step1', 'step2', 'step3', 'step4', 'step5'],
        }
    },
    methods: {
        getStepTitleByLanguage(key) {
            return this.$root.t(`common.${key}`)
        },
    },
}
</script>

<style lang="scss" scoped>
$primary-color: #1076bc;
.wizard {
    max-width: 700px;
    margin: 1.5rem 0;
    margin-top: 50px;
    .nav-tabs {
        display: flex;
        justify-content: space-between;
        border-bottom-color: transparent;
        li {
            a {
                position: relative;
                color: #212529;
                .round-tab {
                    width: 30px;
                    height: 30px;
                    line-height: 30px;
                    display: inline-block;
                    border-radius: 50%;
                    background: #fff;
                    text-align: center;
                    font-size: 14px;
                    font-weight: 500;
                    border: 1px solid #ddd;
                }

                .step-title {
                    position: absolute;
                    top: -35px;
                    white-space: nowrap;
                    left: 50%;
                    transform: translateX(-50%);
                    font-size: 14px;
                    font-weight: 500;
                }
            }
        }
        li.active {
            span.round-tab {
                background: $primary-color;
                color: #fff;
                border-color: $primary-color;
            }

            .step-title {
                color: $primary-color;
                font-weight: bold;
            }
        }
    }
}

.connecting-line {
    height: 2px;
    background: lightgrey;
    position: relative;
    top: 17px;
}

.step-disable {
    .step-title,
    .round-tab {
        color: lightgray !important;
    }
}

.bottom {
    position: absolute;
    top: 35px !important;
    white-space: nowrap;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    font-size: 14px;
    font-weight: 500;
}
</style>
